var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: 32,
    height: 32,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    x: -640,
    y: -64,
    width: 1280,
    height: 800,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons1",
    serifId: "Icons"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Strike"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "H1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "H2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "H3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "list-ul"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-1"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-2"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "list-ol"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "list-task"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "vertical-menu"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "horizontal-menu"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "sidebar-2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Pen"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Pen1",
    serifId: "Pen"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "clock"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "external-link"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "hr"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "info"
  })), /*#__PURE__*/React.createElement("g", {
    id: "warning"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.427,7.987c2.183,0.124 4,1.165 5.096,3.281l17.936,36.208c1.739,3.66 -0.954,8.585 -5.373,8.656l-36.119,0c-4.022,-0.064 -7.322,-4.631 -5.352,-8.696l18.271,-36.207c0.342,-0.65 0.498,-0.838 0.793,-1.179c1.186,-1.375 2.483,-2.111 4.748,-2.063Zm-0.295,3.997c-0.687,0.034 -1.316,0.419 -1.659,1.017c-6.312,11.979 -12.397,24.081 -18.301,36.267c-0.546,1.225 0.391,2.797 1.762,2.863c12.06,0.195 24.125,0.195 36.185,0c1.325,-0.064 2.321,-1.584 1.769,-2.85c-5.793,-12.184 -11.765,-24.286 -17.966,-36.267c-0.366,-0.651 -0.903,-1.042 -1.79,-1.03Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.631,40.581l-3.348,0l-0.368,-16.449l4.1,0l-0.384,16.449Zm-3.828,5.03c0,-0.609 0.197,-1.113 0.592,-1.514c0.396,-0.4 0.935,-0.601 1.618,-0.601c0.684,0 1.223,0.201 1.618,0.601c0.395,0.401 0.593,0.905 0.593,1.514c0,0.587 -0.193,1.078 -0.577,1.473c-0.385,0.395 -0.929,0.593 -1.634,0.593c-0.705,0 -1.249,-0.198 -1.634,-0.593c-0.384,-0.395 -0.576,-0.886 -0.576,-1.473Z",
    style: {
      fillRule: "nonzero"
    }
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "plus-circle"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "minus-circle"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "vue"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "cog"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "radio-check"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "eye-slash"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "toggle-off"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "shredder"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "spinner--loading--dots-",
    serifId: "spinner [loading, dots]"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "react"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "check-selected"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "turn-off"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "code-block"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "user"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-beans"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean1",
    serifId: "coffee-bean"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean-filled"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-beans-filled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean2",
    serifId: "coffee-bean"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-paste"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-copy"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcom);
export default __webpack_public_path__ + "static/media/warning_icom.bdeac318dababbb5a0bf362dd08a7292.svg";
export { ForwardRef as ReactComponent };